export default {"src":"/_next/static/media/Connecticut.19abfb0c.svg","height":439,"width":800,"blurWidth":0,"blurHeight":0};